<template>
        <div class="sms-template">
            <h1 class="text-left">Select a WhatsApp Template</h1>

            <ValidationObserver ref="whatsAppTemplateForm" tag="form" v-on:submit.prevent="saveContent()">
                <div>
                    <ul>
                        <li>
                            <label for="template">WhatsApp Template</label>
                            <div>
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <select v-if="automation" v-model="automation.whatsAppTemplateReference" id="template" v-on:change="showSelectedTemplate">
                                        <option v-bind:value="null">Select a Template, or create a new one</option>
                                        <option v-for="(template) of whatsAppTemplates" v-bind:key="template.reference" v-bind:value="template.reference">{{template.name}}</option>
                                    </select>
                                    <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </li>

                        <li>
                            <label for="content">Content</label>
                            <div id="content" class="template__content--read-only">
                                <span v-if="selectedTemplate">{{selectedTemplate.content}}</span>
                            </div>
                        </li>

                        <li>
                            <div class="sms-template__preview">
                                <label for="preview">Preview</label>
                                <div class="sms-template__preview-note">
                                    <span class="">Variables in your message are replaced with sample data and highlighted in</span> <span class='sms-template__preview-variable'>blue</span>
                                </div>
                                <div id="preview" class="sms-template__preview-phone">
                                    <div class="sms-template__preview-bubble" v-html="previewContentHTML"></div>
                                </div>
                            </div>
                        </li>
                    </ul>


                    <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : updating, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>

                    <div class="row" v-show="!updating">
                        <div class="col-6 offset-3">
                            <div class="row">
                                <div class="col-6">
                                    <button class="btn btn-secondary" v-on:click.prevent="cancel">Cancel</button>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary" v-bind:aria-disabled="!changed" v-bind:class="{'btn-disabled' : !changed}">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationObserver>

            <confirm-dialog v-bind:continuePrimaryText="'Save'"
                            v-bind:message="confirmLoseChangesMessage"
                            v-bind:callbackPrimaryName="'save-sms-template'"
                            v-bind:callbackPrimaryReference="'save'"
                            v-if="showConfirmLoseChangesDialog"/>
        </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider, /*extend*/ } from 'vee-validate'

    import { store } from '../store.js'
    import ConfirmDialog from '../components/ConfirmDialog.vue'

    import { variablesMixin } from '../mixins/VariablesMixin'
    import {whatsAppTemplatesMixin} from "../mixins/WhatsAppTemplatesMixin"

    export default {
        name: 'SelectWhatsAppTemplate',
        components: {
            ValidationObserver, ValidationProvider, ConfirmDialog
        },
        mixins: [ variablesMixin, whatsAppTemplatesMixin ],
        data() {
            return {
                reference: null,
                automation: null,
                requiredVariables: [],
                whatsAppTemplates: [],
                selectedTemplate: null,
                changed: false,
                cancelling: false,
                updating: false,
                error: false,
                infoMessage: "",
                confirmLoseChangesMessage: "You have un-saved changes to this SMS template. Would you like to save your work before leaving the page?",
                showConfirmLoseChangesDialog: false,
                navigatingToRoute: ""
            }
        },
        computed: {
            previewContentHTML: function() {
                if (! this.selectedTemplate) {
                    return "";
                }
                let previewText = this.selectedTemplate.content;
                let variables = previewText.matchAll(/\${(.+?)}/g);
                if (variables) {
                    for (let variable of variables) {
                        let value = this.getExampleForVariable(variable[1]);
                        previewText = previewText.replaceAll(variable[0], "<span class='sms-template__preview-variable'>" + value + "</span>");
                    }
                }
                return previewText;
            }
        },
        methods: {
            showSelectedTemplate: function() {
                if (this.automation.whatsAppTemplateReference) {
                    for (let template of this.whatsAppTemplates) {
                        if (template.reference === this.automation.whatsAppTemplateReference) {
                            this.selectedTemplate = template;
                            this.changed = true;
                            break;
                        }
                    }
                } else {
                    this.changed = false;
                    this.selectedTemplate = null;
                }
            },
            cancel: function() {
                console.log("cancel");
                this.cancelling = true;
                this.$router.push({name: 'Automations'});
            },
            validateContent() {
                console.log("validating WhatsApp content");
                for (let requiredVariable of this.requiredVariables) {
                    let variable = '${' + requiredVariable.name + '}';
                    if (this.selectedTemplate.content.indexOf(variable) < 0) {
                        this.error = true;
                        this.infoMessage = "Your WhatsApp is missing the required variable '" + variable + "', which is required in order to send this WhatsApp to guests.";
                        return false;
                    }
                }
                return true;
            },
            saveContent: async function() {
                console.log("saving");
                if (!this.changed) {
                    return;
                }
                if (this.validateContent()) {
                    try {
                        const success = await this.$refs.whatsAppTemplateForm.validate();
                        console.log("Validated:" + success);
                        if (!success) {
                            return;
                        }
                        this.updating = true;
                        this.error = false;
                        this.infoMessage = "Saving WhatsApp template selection";

                        const body = {
                            reference: "" + this.automation.whatsAppTemplateReference,
                        };

                        const response = await this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/automations/whatsapps/' + this.automation.reference + "/select-template", body);
                        console.log("WhatsApp template updated. Response: " + response);
                        this.infoMessage = "WhatsApp template selected";
                        this.changed = false;
                        setTimeout(() => {
                            this.updating = false;
                        }, 2000);
                    } catch (error) {
                        this.updating = false;
                        this.error = true;
                        if (error.response) {
                            this.infoMessage = error.response.data.message;
                        } else {
                            this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again";
                        }
                    }
                }
            }
        },
        mounted: async function() {
            // this.contentInput = this.$refs.content;

            await this.fetchWhatsAppTemplates();
            await this.fetchVariables();

            if (this.$route.query && this.$route.query.requiredVariables) {
                this.requiredVariables.splice(0, this.requiredVariables.length);
                const requiredVariable = {"name": this.$route.query.requiredVariables, "value": ""};
                this.requiredVariables.push(requiredVariable);
                this.variablesCopy.push(requiredVariable);
            }
            this.sortVariables();

            this.reference = this.$route.params.reference;
            this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/automations/' + this.reference).then(response => {
                this.automation = response.data;
                this.showSelectedTemplate();
                this.changed = false;
            }).catch(error => {
                console.log(error)
            });

            this.saveBeforeLeavingFn = async (action) => {
                if (action === "save") {
                    await this.saveContent();
                    this.$router.push({name: this.navigatingToRoute.name });
                    this.showConfirmLoseChangesDialog = false;
                } else {
                    this.showConfirmLoseChangesDialog = false;
                }
            };
            this.$root.$on('save-sms-template', this.saveBeforeLeavingFn);
        },
        beforeDestroy () {
            this.requiredVariables.splice(0, this.requiredVariables.length);
            this.$root.$off('save-sms-template', this.saveBeforeLeavingFn);
        },
        beforeRouteLeave (to, from, next) {
            if (this.changed && !this.cancelling) {
                this.navigatingToRoute = to;
                this.showConfirmLoseChangesDialog = true;
            } else {
                next();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/layout/forms.scss";
    @import "../styles/components/question_answer";
    @import "../styles/pages/edit-sms";
    @import "../styles/components/edit_template";


    // Todo: ::v-deep Deprecated in Vue 3
    .sms-template__preview ::v-deep .sms-template__preview-variable {
        display: inline-block;
        border: 1px dotted $blue-dark;
        background-color: $blue-light;
        padding: 0 3px;
        color: $black;
    }
</style>

